export default "__VITE_ASSET__CulrxF8C__"